import { BordOneToneIcon } from 'components/NudosComponents';
import { TbordOneToneIcon } from 'components/NudosComponents/BordOneToneIcon/BordOneToneIcon.types';

import './ButtonAttention.scss';

const ButtonAttention = ({ label, icon }: { label: string; icon?: TbordOneToneIcon }) => {
  return (
    <div className="buttonAttentionContainer">
      <div className="floatAnimation" />
      <div className="buttonTextContainerWarning">
        <BordOneToneIcon className="buttonAttentionInfoIcon" variant={icon || 'info'} stroke="currentColor" standardSize={10}  />
        <span className="text-warning">{label}</span>
      </div>  
    </div>
  );
};

export default ButtonAttention;
